module.exports = __webpack_public_path__ + "static/media/hotspot_info.efe508a2.glb";